import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointService } from './breakpoint/breakpoint.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService implements OnDestroy {
  private channel: 'desktop' | 'tablet' | 'mobile' = 'desktop';
  private isPortrait: boolean = false;
  private channelStyleClass:string = '';

  constructor(private breakpointService: BreakpointService) {

  } async initialize() {
    this.breakpointService.registerChannelChange(this);
    this.breakpointService.registerOrientationChange(this);
  }
  ngOnDestroy(): void {
    this.breakpointService.unregisterChannelChange(this);
    this.breakpointService.unregisterOrientationChange(this);
  }
  notifyScreenResize() {
    this.channel = (this.breakpointService.useMobileStyle) ? 'mobile' : (this.breakpointService.useTabletStyle) ? 'tablet' : 'desktop';
    this.applyChannelToRootDOM(this.channel);
  }

  notifyOrientationChange(isPortrait: boolean) {
    this.isPortrait = isPortrait;
    this.applyOrientationToRootDOM();
  }
  applyChannelToRootDOM(channel:string){
    let htmlEl:any = document.getElementsByTagName('html')[0];
    let newStyleClassName:string = channel + '-channel';
    try{
      htmlEl.classList.remove(this.channelStyleClass + '-channel').add(newStyleClassName);
      htmlEl.setAttribute('id', channel);
    }catch(error){
      console.log('default style class name remove error!');
      htmlEl.classList.add(newStyleClassName);
      htmlEl.setAttribute('id', channel);
    }
    this.channelStyleClass = channel;
  }

  applyOrientationToRootDOM(){
    let htmlEl:any = document.getElementsByTagName('html')[0];
    try{
      if(this.isPortrait){
        htmlEl.classList.add('portrait-oriendation');
      } else {
        htmlEl.classList.remove('portrait-oriendation');
      }
    } catch(error){
      console.log('default style class name remove error!');
    }
  }
  isDesktop():boolean{
    return this.channel == 'desktop';
  }
  isTablet():boolean{
    return this.channel == 'tablet';
  }
  isMobile():boolean{
    return this.channel == 'mobile';
  }
  isPortraitOrientation():boolean{
    return this.isPortrait;
  }
  isHybrid():boolean{
    return (window['cordova']) ? true : false;
  }

}

